import BaseService from '../../BaseService.js';

export default class GesuchVerlaufService extends BaseService {
  constructor(wohnobjektId) {
    super(`gesuche?wohnobjekt=${wohnobjektId}`)
  }
}
